import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiverStatusComponent } from './components/receiver-status/receiver-status.component';
import { MatCardModule } from '@angular/material/card';
import { AppMaterialModule } from '../app-material/app-material.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { HelpListComponent } from './components/help-list/help-list.component';
import { TooltipDeitresModule } from '../common/ui/tooltip/tooltipDeitres.module';
import { BetaWarningComponent } from './components/beta-warning/beta-warning.component';
import { ScheduleEventsDialogComponent } from './components/schedule-events/schedule-events-dialog.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { InputDateCustomizedComponent } from './components/input-date-customized/input-date-customized.component';
import { ScheduleRowComponent } from './components/schedule-row/schedule-row.component';

@NgModule({
  declarations: [
    ReceiverStatusComponent,
    HelpListComponent,
    BetaWarningComponent,
    ScheduleEventsDialogComponent,
    InputDateCustomizedComponent,
    ScheduleRowComponent,
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
    TooltipDeitresModule,
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#FFCC00',
      switchColor: 'white',
      defaultBgColor: '#F2F5F8',
      defaultBoColor: 'transparent',
    }),
  ],
  exports: [InputDateCustomizedComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
